import { initialState } from './quiz';

export default () => {
    return {
        quizAssessment: initialState
    }   
}
